// extracted by mini-css-extract-plugin
export default {"unit":"styles_unit__lAZ8D","subHeader":"styles_subHeader__ixfK9","mandatoryMark":"styles_mandatoryMark__yaK64"};